import "../../media/css/TablePrenotazioni.css";
import React from 'react';
import {Button, Label, Table, UncontrolledTooltip} from 'reactstrap';
import AddToHomeScreen from "../AddToHomeScreen.mjs";
import AppModeSwitcher from "../AppModeSwitcher.mjs";
import {ts2hhmm, ts2uidate} from "../../Services/Conversions.mjs";

const localStoreRepo = {};

const localStore = (data) => {
	Object.keys(localStoreRepo).forEach(k => { delete localStoreRepo[k] });
	if ( Array.isArray(data) ) data.forEach( d => {
		localStoreRepo[String(d.kprenotazione)] = d;
	});
}

const editAction = (evt) => {
	const k = evt.target.closest('tr').dataset.k;
	const data = localStoreRepo[String(k)];
	if ( data ) {
		window.glob.setStatus('operation','editP', data);
	}
};

const rmAction = (evt,to) => {
	const tr = evt.target.closest('tr');
	setTimeout( ()=>{ doRemove(tr) }, 10);
	return void(0);
};

const doRemove = ( tr, confirmed ) => {
	if ( ! confirmed ) {
		if ( ! window.confirm(`Sei certo di voler eliminare questa prenotazione?\n
“${ tr.querySelector('td.corso').innerText}” 
Il ${ tr.querySelector('td.data').innerText}, dalle ${ tr.querySelector('td.oraInizio').innerText} alle ${ tr.querySelector('td.oraFine').innerText}`
		)) return void(0);
		return setTimeout( ()=>{ doRemove(tr,true) },10);
	}
	const k = tr.dataset.k;
	window.glob.api('rm',{ kprenotazione: k} ).then( ()=>{
		window.glob.trigger('plistUpdate' );
	});
};

const ButtonDelete = class extends React.Component {
	constructor(props) {
		super(props);
		this.ref = React.createRef();
	}
	render() {
		return(
			<>
				<button
					className={"btn danger"}
					onClick={rmAction}
					aria-label={"Elimina"}
					ref={this.ref}
				>
					🗑
				</button>
				<UncontrolledTooltip target={this.ref} placement={"auto-end"}>
					Elimina la prenotazione
				</UncontrolledTooltip>
			</>
		);
	}
};
const ButtonEdit = class extends React.Component {
	constructor(props) {
		super(props);
		this.ref = React.createRef();
	}
	render() {
		return(
			<>
				<button
					className={"btn"}
					onClick={editAction}
					aria-label={"Modifica"}
					ref={this.ref}
				>
					⚙️️
				</button>
				<UncontrolledTooltip target={this.ref} placement={"bottom-end"}>
					Modifica la prenotazione
				</UncontrolledTooltip>
			</>
		);
	}
};

class TablePrenotazioniRow extends React.Component {
	constructor(opts) {
		super(opts);
		this.locked = !! parseInt(opts.kfrozen);
	}
	render() {
		const d = this.props.data;

		return(
			<tr data-k={d.kprenotazione} className={ this.locked ? 'edit-disabled' : 'edit-enabled' }>
				<td className={"data"}>
					{ ts2uidate(d.tinizio) }
				</td>
				<td className={"ora oraInizio"}>
					{ ts2hhmm(d.tinizio) }
				</td>
				<td className={"ora oraFine"}>
					{ ts2hhmm(d.tfine) }
				</td>
				<td className={"aa"}>
					{ d.laa.replace(/\d{2}(\d{2})/g,"$1") }
				</td>
				<td className={"cdl"}><label>{ d.lentenomeof }</label></td>
				<td className={"classe"}><label>{ d.lclasse }</label></td>
				<td className={"corso"}><label>{ d.lofnome }</label></td>
				<td className={"anno"}><label>{ d.lofanno.replace(/ Anno/i,'') }</label></td>
				<td className={"canale"}><label>{ d.lcanale || '—' }</label></td>
				<td className={"azioni"}>
					{ this.locked ? '' :
						(<div role={"group"} className={"btn-group btn-group-sm"}>
							<ButtonDelete />
							<ButtonEdit />
						</div>)
					}
				</td>
			</tr>
		);
	}
}

class TablePrenotazioni extends React.Component {
	constructor(opts) {
		super(opts);
		this.state = {};
		this.uid = "TablePrenotazioni-"+window.glob.generateUid();
		this.update = this.update.bind(this);
		this.toolbar = this.toolbar.bind(this);
		this.addPrenotazione = this.addPrenotazione.bind(this);
	};
	componentDidMount() {
		window.glob.register('plistUpdate', (data)=>{ this.update(data) }, this.uid );
	};
	componentWillUnmount() {
		window.glob.unregister('plistUpdate', this.uid );
	};
	toolbar(tb,tb2) {
		setTimeout( ()=>{ window.glob.setStatus('toolbar',tb,tb2); },0 );
	}
	update( data ) {
		if ( Array.isArray(data) ) {
			localStore(data);
			this.setState({ data: data, error: false });
		} else {
			window.glob.api('ls').then( rdata => {
				localStore(rdata);
				this.setState({ data: rdata, error: false });
			}).catch( (error)=>{
				this.setState({ error: error });
			});
		}
	}
	addPrenotazione() {
		window.glob.setStatus('operation','newP');
	}

	render() {
		if ( this.state.error ) {
			this.toolbar("");
			return (
				<div className={"mt-3 error text-center"}>
					<h3 className={"text-center"}>Si è verificato un errore</h3>
					<Button onClick={()=>{ this.update() } }>Riprova</Button>
				</div>
			);
		}
		if ( ! Array.isArray(this.state.data) ) {
			this.toolbar("");
			setTimeout( ()=>{ this.update() }, 10 );
			return <h3 className={"mt-3 text-center"}>Caricamento in corso…</h3>;
		}
		const tb = (
			<Button color={"success"} onClick={this.addPrenotazione} className={"btn-icon"}>
				<i>✚</i>
				<b>Nuova<span className={"mobile-no"}> prenotazione</span></b>
			</Button>
		);
		if ( this.state.data.length === 0 ) {
			this.toolbar(tb,<Label>← Aggiungi una prenotazione</Label>);
			return (<>
				<h2 className={"text-center mt-3"}>Nessuna prenotazione presente</h2>
				<AddToHomeScreen />
				<AppModeSwitcher />
			</>);
		}
		this.toolbar(tb,<Label>Prenotazioni presenti: { this.state.data.length }</Label>);
		return (
			<>
				<div className={"TablePrenotazioni"}>
					<h3 className={"text-center mt-2"}>Prenotazioni di esami inserite</h3>
					<Table size={"sm"} striped={true} responsive={true} id={this.uid}>
						<thead>
						<tr>
							<th className={"data"}>Data</th>
							<th className={"ora oraInizio"}>Inizio</th>
							<th className={"ora oraFine"}>Fine</th>
							<th className={"aa"}>A. A.</th>
							<th className={"cdl"}>CdL</th>
							<th className={"classe"}>Classe</th>
							<th className={"corso"}>Corso</th>
							<th className={"anno"}>Anno</th>
							<th className={"canale"}>Canale</th>
							<th className={"azioni"}></th>
						</tr>
						</thead>
						<tbody>
						{ this.state.data.map( r => <TablePrenotazioniRow key={r.kprenotazione} data={r} />) }
						</tbody>
					</Table>
				</div>
				<AddToHomeScreen />
				<AppModeSwitcher />
			</>
		)
	}
}

export default TablePrenotazioni;